import { render, staticRenderFns } from "./task-mobile-card.vue?vue&type=template&id=7f6d2d2c&scoped=true"
import script from "./task-mobile-card.vue?vue&type=script&lang=js"
export * from "./task-mobile-card.vue?vue&type=script&lang=js"
import style0 from "./task-mobile-card.vue?vue&type=style&index=0&id=7f6d2d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d2d2c",
  null
  
)

export default component.exports